import { ICommitment } from "./Commitment";
import { IReportingProgressUpdateWithDeliveryDates, ReportingProgressUpdateWithDeliveryDates } from "./ReportingProgressUpdate";

export interface ICommitmentUpdate extends IReportingProgressUpdateWithDeliveryDates {
    CommitmentID: number | null;
    Commitment?: ICommitment;
}

export class CommitmentUpdate extends ReportingProgressUpdateWithDeliveryDates implements ICommitmentUpdate {
    public CommitmentID : number | null = null;

    constructor(commitmentId: number, period?: Date) {
        super(period);
        this.CommitmentID = commitmentId;
    }
}